import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-sky-100 bg-white/95 shadow-sm backdrop-blur" data-id="element-334">
      <div className="bg-primary px-3 py-1.5 text-center font-display text-[10px] font-bold tracking-wide text-white sm:text-xs md:text-sm" data-id="element-335">
        🇦🇷 Sistema N°1 para Profesores/as, Instructores y Entrenadores en
        Argentina
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-medium text-slate-500 md:flex" data-id="element-336">
        <span className="flex items-center gap-1.5" data-id="element-337">
          <ZapIcon className="h-3.5 w-3.5 text-teal" data-id="element-338" /> Acceso en 5 minutos
        </span>
        <span className="text-slate-300" data-id="element-339">·</span>
        <span className="flex items-center gap-1.5" data-id="element-340">
          <LockIcon className="h-3.5 w-3.5 text-teal" data-id="element-341" /> Pago seguro
        </span>
        <span className="text-slate-300" data-id="element-342">·</span>
        <span className="flex items-center gap-1.5" data-id="element-343">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-teal" data-id="element-344" /> Garantía de 7
          días
        </span>
      </div>
    </header>;
}